<template lang="html">

  <section class="app-footer print_hide">
    <footer class="footer">
      <div class="container-fluid clearfix">
        <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">{{$t('Copyright')}} © 2021. {{$t('All rights reserved')}}.</span>
        <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Nordtech <img width="25px" class="ml-2" src="../../assets/images/fav_nordtech.png" alt="image"/></span>
      </div>
    </footer>
  </section>

</template>

<script lang="js">
export default {
  name: 'app-footer'
}
</script>

<style scoped lang="scss">
.app-footer {

}
</style>



// WEBPACK FOOTER //
// src/components/partials/AppFooter.vue